<template>
    <div
        class="ImageTextLong"
        :class="{'ImageTextLong--rev' : alignment}"
    >
        <BaseImage
            v-if="image"
            classes="BaseImage--ImageTextLong"
            :placeholder="placeholder"
            :srcset="image"
            :ratio="1"
        />

        <div
            class="ImageTextLong__text">

            <BaseHeading
                v-if="heading"
                :heading="heading"
                :preheading="preheading"
                tag="h3"
                class="noline"
            />

            <BaseText
                :text="text"
                class="mt-spacer mb-medium"
            />

            <BaseButton
                v-if="button"
                :href="url"
            >
                {{ button }}
            </BaseButton>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ImageTextLong',
    props: {
        heading: {
            type: String,
            default: null,
        },
        preheading: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        image: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        alignment: {
            type: Boolean,
            default: false
        },
        button: {
            type: String,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
    }
}
</script>
<style lang="scss" scoped>
    .ImageTextLong {
        display: flex;
        flex-direction: column-reverse;

        @include media-query(lap-and-up) {
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .ImageTextLong--rev {
        flex-direction: row-reverse;

        @include media-query(palm) {
            flex-direction: column;
        }
    }

    .ImageTextLong__text {
        @include media-query(lap-and-up) {
            width: 48%;
            padding-right: 2%;
        }
    }

    .BaseButton {
        margin-top: 0.5rem;
    }
</style>
